import React from 'react';
import PropTypes from 'prop-types';
import { observer, PropTypes as MPropTypes } from 'mobx-react';
import { withNamespaces, Trans } from 'react-i18next';
import { staticURL } from 'core/url';
import DocumentHead from 'legacyComponents/documentHead';

import Header from 'apps/components/header/header';
import { ContentIntro } from 'apps/components/contentIntro';
import Paragraph from 'components/Paragraph';
import Icon from 'components/Icon';
import Button from 'components/Button';
import { ExternalLink } from 'core/routing';

import {
  SeniorFullStack,
  SeniorBackend,
  SeniorBackendGolang,
  HeadBusiness,
  HeadGrowth,
  GrowthManager,
  ContentCreator,
  SeniorUIDeveloper,
} from 'apps/home/company/careers/jds';

import {
  Container,
  HeadingStyled,
  StyledLink,
  ImageStyled,
} from '../company.styled';

const jobDescriptions = {
  'senior-fullstack-engineer': SeniorFullStack,
  'senior-back': SeniorBackend,
  'senior-back-golang': SeniorBackendGolang,
  'head-of-business-development': HeadBusiness,
  'head-of-growth-and-monetisation': HeadGrowth,
  'digital-community-growth-manager': GrowthManager,
  'technical-content-creator': ContentCreator,
  'senior-ui-developer': SeniorUIDeveloper,
};

export const Careers = withNamespaces()(
  observer(props => {
    const jd = props.params && props.params.get('position');
    if (!jd) {
      // FIXME - don't reuse jd as identifier
      // eslint-disable-next-line
      const jobs = Object.entries(jobDescriptions).map(jd => {
        const JDComponent = jd[1];
        return <JDComponent key={jd[0]} jobPath={jd[0]} />;
      });
      return (
        <>
          <DocumentHead
            title='Careers'
            imagePath={staticURL('assets/wikifactory.jpg')}
          />
          <Header isDark />
          <ContentIntro
            title='Careers'
            hideButtonWhenSignIn
            variant='secondary'
            isCentered
          />
          <Container>
            <HeadingStyled level='2' size='large'>
              <Trans>Join our growing team</Trans>
            </HeadingStyled>
            {/* TODO: add this source responsive images control for the image component */}
            <picture>
              <source
                // TODO: replace mediaquery by value from theme
                media='(min-width: 800px)'
                srcSet={staticURL('/assets/home/careers-lg.jpg')}
              />
              <ImageStyled src={staticURL('/assets/home/careers.jpg')} />
            </picture>
            <Paragraph size='medium'>
              <Trans>
                Would you like to join an exciting start-up with ambitious plans
                in a fast growing, multi-billion dollar industry? Apply your
                experience in disruptive technologies that will transform every
                aspect of product development? Be part of an international team
                that is curious, committed and collaborative?
              </Trans>
            </Paragraph>
            <Paragraph size='medium'>
              <Trans>
                We’re always on the look out for ambitious talent with the right
                skills and attitude to offer.
              </Trans>
            </Paragraph>
          </Container>
          {false && (
            <Container>
              <HeadingStyled level='2' size='large'>
                <Trans>Current openings</Trans>
              </HeadingStyled>
              {jobs}
            </Container>
          )}

          <Container center>
            <ExternalLink to='https://wikifactory.bamboohr.com/jobs/'>
              <Button outline text={<Trans>View current openings</Trans>} />
            </ExternalLink>
          </Container>
        </>
      );
    }
    const JobComponent = jobDescriptions[jd];
    return (
      <>
        <Header isDark />
        <ContentIntro
          title='Careers'
          hideButtonWhenSignIn
          variant='secondary'
          isCentered
        />
        <Container>
          <StyledLink name='home.company.careers'>
            <Icon name='arrow_left' /> <Trans>Back to all Positions</Trans>
          </StyledLink>
          {JobComponent ? (
            <JobComponent isExpanded />
          ) : (
            <div>
              <Trans>Not found</Trans>
            </div>
          )}
        </Container>
      </>
    );
  }),
);

Careers.propTypes = {
  t: PropTypes.func,
  params: MPropTypes.observableMap,
};
